import { useRef, useState } from 'react'
import ConfirmModal from '@components/ui/ConfirmModal'

/**
 * Remplace `window.confirm()` par une modale de confirmation stylée.
 *
 * Usage :
 *   const { confirm, ConfirmDialog } = useConfirm()
 *   ...
 *   if (!(await confirm({ message: 'Supprimer ?', type: 'danger' }))) return
 *   ...faire l'action...
 *   // et dans le JSX : {ConfirmDialog}
 */
export default function useConfirm() {
  const [opts, setOpts] = useState(null)
  const resolverRef = useRef(null)

  const confirm = (options = {}) =>
    new Promise((resolve) => {
      resolverRef.current = resolve
      setOpts(options)
    })

  const finish = (result) => {
    setOpts(null)
    const r = resolverRef.current
    resolverRef.current = null
    r?.(result)
  }

  const ConfirmDialog = (
    <ConfirmModal
      isOpen={!!opts}
      onClose={() => finish(false)}
      onConfirm={() => finish(true)}
      {...(opts || {})}
    />
  )

  return { confirm, ConfirmDialog }
}
